const ReviewsCarousel = {
  init() {
    if ( !window.tinySlider ) {
      return;
    }
    $('.js-reviews-carousel').each( (_, el) => {
      const $$ = $(el);
      const $items = $$.find('.js-carousel-item');
      if ( $items.length > 1 ) {
        tinySlider({
          container: $$.get(0),
          controls: false,
          items: 1,
        });
      }
    })
  },
};
$(ReviewsCarousel.init.bind(ReviewsCarousel));
